<template>
    <div class="table-comp" :class="customClass">

        <div class="floated-background"></div>
        <div class="table-comp__wrapper">
            <div class="table-comp__scroll scroll-table">
                <span v-if="showNoData && tableData.length === 0">No data.</span>

                <table class="table-comp__floating-table" :id="customId" :name="name">
                    <thead>
                        <tr>
                            <template
                                v-for="(colHeader, colHeaderIndex) in columns"
                                :key="customId + '-th-' + colHeaderIndex">
                                <v-col
                                    :th="true"
                                    :noSort="noSort"
                                    :column="colHeader"
                                    v-if="colHeader.display !== false"
                                />
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template
                            v-for="(dataRow, dataRowIndex) in tableData"
                            :key="customId + '-data-row-' + dataRowIndex">
                            <tr
                                v-if="checkEmptyRow(dataRow)"
                            >
                                <template
                                    v-for="(colRow, colRowIndex) in columns"
                                    :key="customId + '-td-' + colRowIndex"> 
                                    <v-col
                                        :tableName="tableName"
                                        :data="dataRow"
                                        :column="colRow"
                                        v-if="colRow.display !== false"
                                    />
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="floated-header">
                <div class="floated-header__table-wrapper">
                    <table class="no-float">
                        <colgroup>
                            <template
                                v-for="(column, colGroupIndex) in columns"
                                :key="customId + '-table-colgroup-col' + colGroupIndex"
                                >
                                    <col v-if="column.display !== false"
                                    >
                            </template>
                        </colgroup>
                        <thead>
                            <tr>
                                <template v-for="(colHeader, colHeaderIndex) in columns"
                                    :key="customId + '-th-' + colHeaderIndex">
                                        <v-col
                                            :th="true"
                                            :noSort="noSort"
                                            :column="colHeader"
                                            @filter="filter"
                                            :customClass="sortField == colHeader.dataField ? ('active ' + sortDir) : ''"
                                            :floated="true"
                                            v-if="colHeader.display !== false"
                                        />
                                    </template>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isString } from 'util';
import bus from '@/js/event-bus.js';
export default {
    name: 'v-table',
    props: {
        tableName: {
            type: String,
            required: true
        },
        customId: {
            type: String,
            required: true
        },
        customClass: {
            type: String,
        },
        columns: {
            type: Array,
            required: true
        },
        tableData: {
            type: Array,
            required: true
        },
        sortField: {
            type: String
        },
        sortDir: {
            type: String
        },
        noSort: {
            type: Boolean,
            default: false
        },
        name: {
            type: String
        },
        showNoData: {
            type: Boolean
        }
    },
    watch: {
        columns: function () {
            this.floatTableHeader();
        },
        tableData: function () {
            this.floatTableHeader();
        }
    },
    mounted () {
        $(this.$el).find('.table-comp__floating-table').floatTableColumn();

        bus.$on('sort:click', (data) => {
            this.sort(data);
        })
        setTimeout(() => {
            if (this.tableName === 'mainTable' || this.tableName === 'rcdcTable') {
                window.calculateScrollTableHeight($(this.$el).find('.scroll-table'));

                $(window).resize(() => {
                    window.calculateScrollTableHeight($(this.$el).find('.scroll-table'));
                });
            }
        }, 301);

        this.$nextTick(() => {
            $(this.$el).find('.table-comp__floating-table').floatTableHeader();
        });
    },
    methods: {
        floatTableHeader () {
            this.$nextTick(() => {
                $(this.$el).find('.table-comp__floating-table').floatTableHeader();
            });
        },
        checkEmptyRow (dataRow) {
            var count = 0;

            if (this.$route.name === 'ic') {
                return true;
            } else {
                for (let index = 1; index < this.columns.length; index++) {
                    const column = this.columns[index];

                    if ((Number(dataRow[column.dataField]) === 0 || dataRow[column.dataField] === null || isNaN(dataRow[column.dataField])) && !isString(dataRow[column.dataField])) {
                        count++;
                    }
                }

                return count !== this.columns.length - 1;
            }
        },
        sort (dataField) {
            if (this.sortField === dataField) {
                bus.$emit('update:sortDir', this.sortDir === 'desc' ? 'asc' : 'desc');
            } else {
                bus.$emit('update:sortField', dataField);
                bus.$emit('update:sortDir', 'asc');
            }
        },
        filter (data) {
            bus.$emit('filter', data);
        }
    }
};
</script>

<style lang="scss">
.floated-header {
    position: absolute;
    // left: 0;
    // padding: 0 45px;
    table {
        table-layout: fixed;
        position: relative;
        top: 0;
        left: 0;
        max-width: none;

        th {
            height: 100%;
            .header {
                position: relative;
                vertical-align: top;
                background: #555;
                color: #fff;
                font-family: Roboto,Helvetica,Arial,sans-serif;
                font-size: 13px;
                font-weight: 700;
                line-height: 1em;
                height: 100%;
                padding-right: 18px;
                .sort-controls {
                    position: relative;
                    float: left;
                    height: 100%;
                    cursor: pointer;
                    // padding: 10px 30px 10px 10px;
                    padding: .5em 18px .5em 5px;

                    &:hover:not(.no-sort) {
                        background-color: lighten(#555, 10%);
                    }
                }

                .filter-controls {
                    position: absolute;
                    left: 100%;
                    height: 100%;

                    button {
                        height: 100%;
                        width: 18px;
                    }

                    &:hover {
                        background-color: lighten(#555, 10%);
                    }
                }

                .sort-icons {
                    position: absolute;
                    top: 0;
                    right: 12px;
                }

                &.no-sort {
                    cursor: default;

                    .sort-controls {
                        cursor: default;

                        .sort-icons {
                            display: none;
                        }
                    }
                }

                .column-filter {
                    z-index: 10;
                    position: absolute;
                    top: 101%;
                    box-shadow: 0 8px 15px rgba(0,0,0,.33);
                    border-bottom-left-radius: 4px;
                    border-bottom-right-radius: 4px;

                    label {
                        @include sr-only;
                    }

                    input {
                        width: 100%;
                    }
                }

                .column-filter__wrapper {
                    text-align: left;
                    min-width: 200px;
                    background-color: #f2f2f2;
                    color: #000;
                    overflow: hidden;
                    padding: 5px;
                }

                .column-filter__controls {
                    cursor: default;
                    padding: 9px 0 3px;

                    button {
                        &:active,
                        &:focus {
                            box-shadow: none;
                        }
                    }

                    .btn-secondary {
                        background-color: #555;
                        color: #fff;
                        border: none;
                        border-radius: 2px;

                        &:hover {
                            background-color: #6f6f6f;
                            box-shadow: none;
                        }
                    }

                    .btn-primary {
                        background-color: #015496;
                        color: #fff;
                        border: none;
                        float: right;
                        border-radius: 2px;

                        &:hover {
                            background-color: #0170c9;
                            box-shadow: none;
                        }
                    }
                }
            }

            .header__content {
                display: inline-block;
                position: relative;
                height: 100%;
            }

            &.active {
                .header {
                    background-color: lighten(#555, 5%);
                }

                &.desc {
                    .header__sort-icon-down {
                        color: #dedada;
                    }
                }
                &.asc {
                    .header__sort-icon-up {
                        color: #dedada;
                    }
                }
            }

            .svg {
                width: 8px;
                height: 8px;
                position: absolute;
                color: #9e9c9c;

                &.header__sort-icon-up {
                    top: 5px;
                }
                &.header__sort-icon-down {
                    top: 12px;
                }

                &.icon-filter-icon {
                    width: 16px;
                    height: 16px;
                    top: 4px;
                    left: 0px;
                }
            }
        }
    }
}

table {
    width: 100%;
    th {
        color: #fff;
        background: #555;
        line-height: 1.2em;
        font-size: 13px;
    }

    td {
        font-size: 13px;
        height: 1.8em;
        font-weight: 400;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        line-height: 1.2em;
        padding: 0;
        border-bottom: 1px solid #ddd;
        vertical-align: top;

        > div {
            padding: 5px 10px;
            // height: 100%;
        }
    }

    th, td {
        text-align: left;

        &:first-child {
            // padding: 0 0 0 $home-page-padding!important;
            min-width: 200px;

            .rcdc-title {
                padding: 5px 0 5px 10px;
            }
        }

        // &:last-child {
        //     padding-right: $home-page-padding;
        // }
    }

    &:not(.no-float) { // not a floated header table
        thead {
            th {
                padding: 0;
                color: #fff;
                height: 0;
                background: #555;
                .header {
                    overflow: hidden;
                    padding-left: 5px;
                    padding-right: 36px;
                }
            }
        }
    }
}

/* IE hacks */
.ie {
    table td {
        border-bottom: none;
    }

    table td > div {
        height: 100%;
        border-bottom: 1px solid #ddd;
    }
}

.table-comp {
    position: relative;
    height: 100%;
    // overflow: hidden;
    padding: 0px 45px;
}

.table-comp__wrapper {
    height: 100%;
    overflow: hidden;
    // width: 100%;
    position: relative;
}

.table-comp__scroll {
    position: relative;
    overflow: auto;
    height: 100%;
    transition: 0.2s;
}

.table-comp__floating-table {
    position: relative;
}

th:nth-child(1),
td:nth-child(1) {
    position: relative;
    z-index: 10;
}

td:nth-child(1) {
    div {
        background-color: #fff;
    }
}

.floated-background {
    position: absolute;
    top: 0;
    width: 100%;
    background-color: #555;
    left: 0;
    // z-index: 30;
}
.v-hidden {
    visibility:hidden;
    div {
        line-height: 1px;
    }
}
// .floated-header__table-wrapper {
//     // padding: 0 45px;
//     // background-color: #555;
// }

</style>



